export function wrapWithHook(callback, hook) {
  if (hook) {
    return hook(callback);
  }

  return callback();
}